export default __webpack_public_path__ + "static/media/404error.5bea3a65.svg";